import styled from 'styled-components';
import { TextField } from '@mui/material';

export const BackgroundContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: linear-gradient(90deg, rgba(106,27,154,1) 0%, rgba(255,145,77,1) 50%, rgba(106,27,154,0.8) 100%);
  position: relative;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 0;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2), 0px 12px 24px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
  position: relative;
  z-index: 1;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.25), 0px 16px 32px rgba(0, 0, 0, 0.25);
  }
`;

export const LogoContainer = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
`;

export const ContentContainer = styled.div`
  padding: 20px;
  width: 100%;
`;

export const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border-radius: 8px;
  }
`;

export const LogoImage = styled.img`
  width: 140px;
`;